import React, { forwardRef } from "react";
import TextField, { TextFieldProps } from "./TextField";

const NumberTextField: React.FC<TextFieldProps> = forwardRef((props, ref) => {
	return (
		<TextField
			{...props}
			ref={ref}
			type="number"
		/>
	);
});

export default NumberTextField;
